export enum MessageType {
  Unknown = 'Unknown',
  Warning = 'Warning',
  Error = 'Error',
  Info = 'Info',
}
